import React, { useState, useEffect } from "react";
import { YhBox } from "@/components/YhBox";
import { Button, Upload, Input, Modal, Switch, Form, Image } from "antd";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { useBusinessModel } from "../businessModel";
import "../business.scss"
import { __FormFileImage as FormFileImage } from "@/components/YhFormBox/item/FormFileImage";
import { DeleteOutlined, EyeOutlined, PlusOutlined } from "@ant-design/icons";
import { UploadChangeParam } from "antd/lib/upload";
import { RcCustomRequestOptions, UploadFile } from "antd/lib/upload/interface";
import { BusinessImgList, BusinessImgType, IBusinessDetail, IBusinessImg, IUploadImg } from "../businessTypes";

import { contentService } from "@/views/content/contentService";
import { COSUploadFile } from "@/utils/uploadFile";
export const DetailsBox = () => {
    const {
        initImgList,
        addFormVal,
        addMd5List,
        editMd5List,
        editFormVal,
        insertDetail,
        editDetail,
        getDetailEditOne,
        resetAddCatch,
        resetEditCatch,
        setSelectedRow,
        setSelectedRowKeys,
        loadData,
    } = useBusinessModel();
    const { selectedNavId, getSelectedNavState, findNav, replaceNav } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const { id, mode } = detailsInfo;
    const [form] = Form.useForm();
    const [imageForm] = Form.useForm();

    const [previewVisible, setPreviewVisible] = useState(false)
    const [previewFormVisible, setPreviewFormVisible] = useState(false)
    const [previewImage, setPreviewImage] = useState("")
    const [previewTitle, setPreviewTitle] = useState("")
    const [formType, setFormType] = useState<BusinessImgType>()
    const [formData, setFormData] = useState<{ url?: string, md5?: string; id?: string; title?: string, upload?: any }>()
    const [fileList, setFileList] = useState<BusinessImgList>(initImgList)
    const [formVal, setformVal] = useState<IBusinessDetail>({}) //表单的值;
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (mode === "edit") {
            if (!Object.keys(editFormVal).length) {
                getDetailEditOne(id)
            }
        } else {
            if (!Object.keys(addFormVal).length) {
                setFileList(addMd5List)
                setformVal(addFormVal)
            }
        }
    }, [id, mode])

    useEffect(() => {
        if (mode === "edit") {

            setformVal(editFormVal)
            form.setFieldsValue({
                ...editFormVal,
                businessStatus: editFormVal.businessStatus === 1,
                coopStatus: editFormVal.coopStatus === 1,
                medalStatus: editFormVal.medalStatus === 1,
                serviceStatus: editFormVal.serviceStatus === 1,
            })
        }
    }, [editFormVal])

    useEffect(() => {
        if (mode === "edit") {
            setFileList(editMd5List)
        }
    }, [editMd5List])

    useEffect(() => {
        return () => {
            !findNav("5-1") && resetAddCatch(mode);
            !findNav("5-2") && resetEditCatch(mode);
        }
    }, [selectedNavId])

    const onSubmit = async () => {
        let list: IBusinessImg[] = [];
        const formData = form.getFieldsValue()

        for (const key in fileList) {
            const items = fileList[key as BusinessImgType]
            items.forEach(item => list.push({
                imgMd5: item.uid,
                imgCategory: key,
                imgTitle: item.title,
                id: item.id,
            } as IBusinessImg))
        }

        const data = {
            ...formVal,
            list,
            ...formData,
            businessStatus: formData.businessStatus ? 1 : 0,
            coopStatus: formData.coopStatus ? 1 : 0,
            medalStatus: formData.medalStatus ? 1 : 0,
            serviceStatus: formData.serviceStatus ? 1 : 0,
        }
        if (mode === "add") {
            const retData = await insertDetail(data)
            if (retData) {
                globalPrompt("message", { text: "业务范围新增成功", type: "success" })
                setSelectedRow([])
                setSelectedRowKeys([])
                resetAddCatch(mode)
                goBack();
            }
        } else {
            const retData = await editDetail(data)
            if (retData) {
                globalPrompt("message", { text: "业务范围编辑成功", type: "success" })
                setSelectedRow([])
                setSelectedRowKeys([])
                resetEditCatch(mode)
                goBack();
            }
        }
    }
    const goBack = async () => {
        await loadData()
        replaceNav(selectedNavId, "5")
    }


    const uploadButton = (
        <div>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>上传</div>
        </div>
    );
    const handleCancel = () => {
        setPreviewFormVisible(false)
        setPreviewVisible(false)
        imageForm.resetFields()
        setFormData({})
    };
    const handeSubmit = () => {
        imageForm.validateFields().then(values => {
            const list = [...fileList[formType as BusinessImgType]]
            if (values?.id) {
                const index = list.findIndex(item => item.id === values.id)
                list[index] = {
                    ...formData,
                    title: values.title,
                    uid: formData?.md5,
                } as IUploadImg
            } else {
                list.push({
                    ...formData,
                    title: values.title,
                    uid: formData?.md5,
                } as IUploadImg)
            }
            const data = { ...fileList }
            data[formType as BusinessImgType] = list as IUploadImg[]
            setFileList(data)
            handleCancel()
        })

    }

    // function getBase64(file: Blob) {
    //     return new Promise((resolve, reject) => {
    //         const reader = new FileReader();
    //         reader.readAsDataURL(file);
    //         reader.onload = () => resolve(reader.result);
    //         reader.onerror = error => reject(error);
    //     });
    // }

    // const handlePreview = async (file: any) => {
    //     if (!file.url && !file.preview) {
    //         file.preview = await getBase64(file.originFileObj);
    //     }

    //     setPreviewImage(file.url || file.preview)
    //     setPreviewVisible(true)
    //     setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1))
    // };

    // const handleChange = (info: UploadChangeParam, type: BusinessImgType) => {
    //     if (info.file.status === "done") {
    //         const list = info.fileList
    //         let md5 = info.file.response.retData as string;
    //         list[list.length - 1].uid = md5
    //         list[list.length - 1].url = `${fileUrl}/file/fetch?id=${md5}`
    //         const data = { ...fileList }
    //         data[type] = list as IUploadImg[]
    //         setFileList(data)
    //     }
    // };
    // const handleImageChange = (info: UploadChangeParam) => {
    //     if (info.file.status === "done") {
    //         let md5 = info.file.response.retData as string;
    //         setFormData({ ...formData, md5, url: `${fileUrl}/file/fetch?id=${md5}` })
    //     }
    // };

    const uploadImage = (type: BusinessImgType) => {
        setPreviewFormVisible(true)
        setFormType(type)
    }
    const editImage = (type: BusinessImgType, item: IUploadImg) => {
        setPreviewFormVisible(true)
        setFormType(type)
        // setPreviewImage(item.url)
        setFormData({ ...item, upload: item.url })
        imageForm.setFieldsValue({ ...item, title: item.title, upload: item.url })
        // setPreviewVisible(true)
        // setPreviewTitle(item.title)
    }
    const onDelteImage = (type: BusinessImgType, index: number) => {
        const list = [...fileList[type]]
        list.splice(index, 1)
        const data = { ...fileList }
        data[type] = list as IUploadImg[]
        setFileList(data)
    }
    const onUpload = (options: RcCustomRequestOptions) => {
        COSUploadFile({
            options,
            onSuccess: (url, md5) => {
                console.log(url)
                setFormData({ ...formData, md5, url })
            },
            // prefix: 'wms',
            onError: (error) => console.log(error),
            // onMD5Progress: setPercent({ ...percent, parsePercent: parseInt(Number(progress) * 100 + '') }),
            // onProgress: setPercent({ ...percent, uploadPercent: parseInt(Number(info.percent) * 100 + '') })
        })
    }

    const UploadFileList = (fileList: IUploadImg[] = [], type: BusinessImgType) => <div className="upload-list">
        <span className="upload-item">
            <span className="upload-item-img" style={{ marginBottom: "25px" }} onClick={() => uploadImage(type)}>
                <PlusOutlined />
                <div style={{ marginTop: 8 }}>上传</div>
            </span>
        </span>
        {fileList.map((item, index) =>
            <span className="upload-item">
                <span className="upload-item-img">
                    <img src={item.url} alt="" width="88px" />
                    <div className="upload-item-img__mask">
                        <Button type="text" size="small" icon={<EyeOutlined style={{ color: "#fff" }} />} onClick={() => {
                            setPreviewImage(item.url)
                            setPreviewVisible(true)
                            setPreviewTitle(item.title)
                            editImage(type, item)
                        }}></Button>
                        <Button type="text" size="small" icon={<DeleteOutlined style={{ color: "#fff" }} />} onClick={() => {
                            onDelteImage(type, index)
                        }}></Button>
                    </div>
                </span>
                <span className="one-line upload-title">{item.title ?? '无标题'}</span>
            </span >
        )}

    </div >

    return <Form form={form} initialValues={formVal} className="business">
        <YhBox title={<span>栏目： <span>{formVal.columnName}</span></span>} style={{ marginTop: "15px" }}>
            <Button
                style={{ marginLeft: "50px" }}
                type="link"
                shape="round"
                onClick={() => onSubmit()}
            >
                保存
            </Button>
            <Button
                style={{ marginLeft: "30px" }}
                type="link"
                shape="round"
                onClick={() => goBack()}
            >
                返回
            </Button>
        </YhBox >
        <YhBox title="* 简介" style={{ marginTop: "15px" }}>
            <div className="px-30">
                <Form.Item name="intro">
                    <Input.TextArea rows={4} />
                </Form.Item>
            </div>
        </YhBox >
        <YhBox
            title="合作品牌"
            style={{ marginTop: "15px" }}
            rightChildren={
                <span className="flex items-center">
                    <span className="pr-5">状态：</span>
                    <Form.Item name="coopStatus" className="mr-20" valuePropName="checked">
                        <Switch size="small" />
                    </Form.Item>
                    <span>更多</span>
                </span>
            }
        >
            <div className="px-30">
                {/* <Upload
                    action={`${fileUrl}/file/uploadFile`}
                    listType="picture-card"
                    fileList={fileList.coopBrand}
                    onPreview={handlePreview}
                    onChange={(val) => handleChange(val, 'coopBrand')}
                >
                    {fileList.coopBrand.length >= 8 ? null : uploadButton}
                </Upload> */}
                {
                    UploadFileList(fileList.coopBrand, 'coopBrand')
                }
            </div>
        </YhBox >
        <YhBox
            title="业务资质"
            style={{ marginTop: "15px" }}
            rightChildren={
                <span className="flex items-center">
                    <span className="pr-5">状态：</span>
                    <Form.Item name="businessStatus" className="mr-20" valuePropName="checked">
                        <Switch size="small" />
                    </Form.Item>
                    <span>更多</span>
                </span>
            }
        >
            <div className="px-30">
                {/* <Upload
                    action={`${fileUrl}/file/uploadFile`}
                    listType="picture-card"
                    fileList={fileList.business}
                    onPreview={handlePreview}
                    onChange={(val) => handleChange(val, 'business')}
                >
                    {fileList.business.length >= 8 ? null : uploadButton}
                </Upload> */}
                {
                    UploadFileList(fileList.business, 'business')
                }
            </div>
        </YhBox >
        <YhBox
            title="荣誉奖章"
            style={{ marginTop: "15px" }}
            rightChildren={
                <span className="flex items-center">
                    <span className="pr-5">状态：</span>
                    <Form.Item name="medalStatus" className="mr-20" valuePropName="checked">
                        <Switch size="small" />
                    </Form.Item>
                    <span>更多</span>
                </span>
            }
        >
            <div className="px-30">
                {/* <Upload
                    action={`${fileUrl}/file/uploadFile`}
                    listType="picture-card"
                    fileList={fileList.medal}
                    onPreview={handlePreview}
                    onChange={(val) => handleChange(val, 'medal')}
                >
                    {fileList.medal.length >= 8 ? null : uploadButton}
                </Upload> */}
                {
                    UploadFileList(fileList.medal, 'medal')
                }
            </div>
        </YhBox >
        <YhBox
            title="服务案例"
            style={{ marginTop: "15px" }}
            rightChildren={
                <span className="flex items-center">
                    <span className="pr-5">状态：</span>
                    <Form.Item name="serviceStatus" className="mr-20" valuePropName="checked">
                        <Switch size="small" />
                    </Form.Item>
                    <span>更多</span>
                </span>
            }
        >
            <div className="px-30">
                {/* <Upload
                    action={`${fileUrl}/file/uploadFile`}
                    listType="picture-card"
                    fileList={fileList.service}
                    onPreview={handlePreview}
                    onChange={(val) => handleChange(val, 'service')}
                >
                    {fileList.service.length >= 8 ? null : uploadButton}
                </Upload> */}
                {
                    UploadFileList(fileList.service, 'service')
                }
            </div>
        </YhBox >
        {/* <Modal
            visible={previewVisible}
            title={previewTitle}
            footer={null}
            onCancel={handleCancel}
        >
            <img alt="example" style={{ width: '100%' }} src={previewImage} />
        </Modal> */}
        <Modal
            visible={previewFormVisible}
            title="图片详情"
            onCancel={handleCancel}
            onOk={handeSubmit}
        >
            <Form
                name="validate_other"
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 14 }}
                form={imageForm}
                initialValues={{

                }}
            >
                <Form.Item name="title" label="标题" rules={[{ required: true, message: "标题为必填项" }]}>
                    <Input />
                </Form.Item>
                <Form.Item name="id" label="ID" style={{ display: 'none' }} rules={[{ required: false, message: "标题为必填项" }]}>
                    <Input />
                </Form.Item>

                <Form.Item
                    name="upload"
                    label="图片"
                    // valuePropName="fileList"
                    rules={[{ required: true, message: "请上传图片" }]}
                >
                    <Upload
                        listType="picture-card"
                        className="avatar-uploader"
                        showUploadList={false}
                        // onChange={(val) => handleImageChange(val)}
                        customRequest={onUpload}
                    >
                        {formData?.url ? <img style={{ width: "100%" }} src={formData?.url} alt="加载失败" /> : uploadButton}
                    </Upload>
                </Form.Item>
            </Form>
        </Modal >
    </Form >
}